import { CONTENT_WRITE_REFUSED_ROLES } from '../auth/roleCapabilities';

// The roles barred from changing any General-tab setting — the same set the legacy
// Apply Changes button used to gate. Shared so every settings control stays in lockstep.
//
// Now an alias of the contentWrite complement, which also gives PUT /api/v1/users/:userId/settings
// its server-side allow-list. The name stays because every General-tab control already reads it.
export const SETTINGS_RESTRICTED_ROLES = CONTENT_WRITE_REFUSED_ROLES;
